module.exports = __webpack_public_path__ + "media/images/athletes/1401-cc4b528969ff03113ff74315b062b735.png";